import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { Toast } from 'vant';
import 'vant/lib/index.css';
import Qrcode from './components/Qrcode.vue'

Vue.use(Toast);
Vue.component('Qrcode', Qrcode)


const policy = (id) => {
  return new Promise((resolve, reject) => {
    fetch(`https://smart.cdtalents.cn:31003/api/chengduTalent-app/app/policy/detail?id=${id}`).then(res => res.json()).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

const verifyUrl = (url) => {
  return new Promise((resolve, reject) => {
    fetch(`https://smart.cdtalents.cn:31003/api/chengduTalent-app/service/verifyUrl?url=${url}`).then(res => res.json()).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

const callNumber = (number) => {
  window.location.href = `tel:${number}`;
}
Vue.prototype.$callNumber = callNumber;
Vue.prototype.$policy = policy;
Vue.prototype.$verifyUrl = verifyUrl;

// console.log(Toast);
Vue.config.productionTip = false
import "@/assets/public.scss";//全局样式
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
